import { Injectable } from '@angular/core';
import {PickerItem, PickerItemType} from '@lib-modules/picker/components/picker-item/picker-item.component';

@Injectable({
  providedIn: 'root'
})
export abstract class BaseCardService {
  protected skip: number = 0;
  protected limit: number = 12;
  protected id?: string;
  protected type?: PickerItemType;
  protected queryParams: any = {};

  protected init(skip: number, limit: number, item?: PickerItem, additionalParams?: any): void {
    this.skip = skip;
    this.limit = limit;
    this.id = item?.objectId;
    this.type = item?.type;
    this.queryParams = {};
    if (this.type) {
      this.queryParams[`${this.type.toLowerCase()}id`] = this.id;
    }
    if (additionalParams) {
      this.queryParams = { ...this.queryParams, ...additionalParams };
    }
  }

  // Abstract methods
  public abstract fetchData(...args: any[]): Promise<any[]>;
}
